export const DlcLimitedTime = () => {
    return (
        <section className='max-w-[1000px] md:my-20 md:pb-20 mx-auto section-deco text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full px-4 md:px-0 md:w-4/5  mt-12'>
            {' '}
            <div className='flex justify-center mt-20'>
                <img
                    className=''
                    alt='limited edition'
                    src={`${process.env.PUBLIC_URL}/images/dlc/header-dlc-limited-fr.webp`}
                />
            </div>
            <h1 className='w-4/5 mx-auto mt-12'>
            Ajoutez à votre compte le DLC bonus gratuit avant que ce dernier ne disparaisse à tout jamais ! Disponible gratuitement jusqu'au 13 février 2025 à 6 h du matin (heure du Pacifique).
            </h1>
            <div className='flex flex-col md:flex-row gap-8 justify-center my-12'>
                <div className=''>
                    <div className='mt-8 flex justify-center max-w-[600px] mx-auto'>
                        <img
                            className='w-full mx-auto'
                            alt='limited edition'
                            src={`${process.env.PUBLIC_URL}/images/dlc/PhantomBrave_TheLostHero_MaronaAsh_PhantomIsleOutfits.webp`}
                        />
                    </div>{' '}
                    <h1 className='text-base text-center mt-4 text-pborange'>Tenues de l'île Fantôme pour <span className="whitespace-nowrap">Marona et Ash </span>
                    </h1>
                    <p className='text-center text-caption'>(Nintendo Switch™, PlayStation®5, et PlayStation®4)</p>
                    {/* <p className='mt-4 text-caption text-center'>Available for free until February 13, 2025 at 6 am PT</p> */}
                </div>{' '}
                <div className=''>
                    {' '}
                    <div className='mt-8 flex justify-center max-w-[600px] mx-auto'>
                        <img
                            className='mx-auto'
                            alt='limited edition'
                            src={`${process.env.PUBLIC_URL}/images/dlc/PhantomBrave_TheLostHero_ExclusivePuttyOutfit_Minty.webp`}
                        />
                    </div>{' '}
                    <h1 className='text-base text-center mt-4 text-pborange'>Tenue Minty pour Putty</h1>
                    <p className='text-center text-caption'>(Nintendo Switch™)</p>
                    {/* <p className='mt-4 text-caption text-center'>Available for free until February 13, 2025 at 6 am PT</p> */}
                </div>{' '}
            </div>
        </section>
    )
}